export enum SecureStorageKeys {
  CUSTOM_TOKEN = "cellera_custom_token",
  RXNT_ACCESS_TOKEN = "rxnt_access_token",
}

export enum SessionStorageKeys {
  SIGN_UP_EMAIL = "signUpEmail",
}
